const ContactInfo = {
    contact_phone: "+923029677678",
    contact_email: "autofinder786@gmail.com",
    address: "G9 Markaz, Islamabad, Pakistan",
    facebook: "https://facebook.com",
    twitter: "https://facebook.com",
    linkedin: "https://facebook.com",
    instagram: "https://facebook.com",
    youtube: "https://www.youtube.com/channel/UCbcMNX986C4Pjc6DOQYObMQ",
}

const cities = [
    "All Pakistan",
    "Karachi",
    "Lahore",
    "Islamabad",
    "Rawalpindi",
    "Faisalabad",
    "Multan",
    "Peshawar",
    "Quetta",
    "Sialkot",
    "Gujranwala",
    "Hyderabad",
    "Sargodha",
    "Bahawalpur",
    "Sukkur",
    "Abbottabad",
    "Mardan",
    "Swat",
    "Kasur",
    "Sheikhupura",
    "Okara",
    "Jhang",
    "Larkana",
    "Rahim Yar Khan",
    "Gujrat",
    "Dera Ghazi Khan",
    "Mirpur",
    "Muzaffarabad",
    "Nawabshah",
    "Chiniot",
    "Khairpur",
    "Charsadda",
    "Nowshera",
    "Kohat",
    "Karak",
    "Bannu",
    "Dera Ismail Khan",
    "Haripur",
    "Kamoke",
    "Turbat",
    "Gwadar",
    "Hub",
    "Jacobabad",
    "Khuzdar",
    "Mansehra",
    "Attock",
    "Hassan Abdal",
    "Lodhran",
    "Toba Tek Singh",
    "Jhelum",
    "Kharian",
    "Wazirabad",
    "Pakpattan",
    "Shikarpur",
    "Badin",
    "Thatta",
    "Matiari",
    "Hala",
    "Mianwali",
    "Bhakkar",
    "Hafizabad",
    "Khanewal",
    "Sadiqabad",
    "Ghotki",
    "Kotri",
    "Shahdadpur",
    "Umerkot",
    "Sanghar",
    "Dadu",
    "Tando Adam",
    "Tando Allahyar",
    "Moro",
    "Khairpur Nathan Shah",
    "Rohri",
    "Chaman",
    "Zhob",
    "Loralai",
    "Pishin",
    "Kalat",
    "Sibi",
    "Vehari",
    "Arifwala",
    "Khanpur",
    "Kot Addu",
    "Muzaffargarh",
    "Jatoi",
    "Chishtian",
    "Hasilpur",
    "Muridke",
    "Kaswal",
    "Mandi Bahauddin",
    "Narowal",
    "Shorkot",
    "Jaranwala",
    "Pattoki",
    "Gilgit",
    "Skardu",
    "Hunza",
    "Nagar",
    "Ghizer",
    "Astore",
    "Diamer",
    "Mirpur AJK",
    "Kotli AJK",
    "Rawalakot",
    "Bagh AJK",
    "Bhimber"
];

const budgetRanges = [
    "Under 5 Lakh",
    "5-10 Lakh",
    "10-15 Lakh",
    "15-20 Lakh",
    "20-30 Lakh",
    "30-50 Lakh",
    "50-75 Lakh",
    "75 Lakh - 1 Crore",
    "Above 1 Crore"
];


const teamMembers = [
    { id: 1, name: "Alice Smith", title: "Project Manager" },
    { id: 2, name: "Bob Johnson", title: "Software Engineer" },
    { id: 3, name: "Catherine Lee", title: "UX Designer" },
    { id: 4, name: "David Brown", title: "Data Analyst" },
    { id: 5, name: "Emily Davis", title: "Marketing Specialist" },
    { id: 6, name: "Frank Wilson", title: "Quality Assurance" },
    { id: 7, name: "Grace Taylor", title: "Content Strategist" },
    { id: 8, name: "Henry Moore", title: "DevOps Engineer" },

];

// Backend API URL - Standardized to 127.0.0.1 to avoid localhost preflight issues
const server_ip = process.env.REACT_APP_SERVER_ADDRESS || 'http://127.0.0.1:8001'

export { ContactInfo, teamMembers, server_ip, cities, budgetRanges }